import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {userAction, GetUserContactsAction} from '../action';

const tableId = 'userContactsProfile';

function* execute({payload: {tableDataRequest}}: GetUserContactsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserContacts,
        successAction: userAction.getUserContactsSuccess,
        tableId,
    }));
}

export function* getUserContactsSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_CONTACTS', execute);
}
